// components
import CommonActionModal from "../Common/CommonActionModal";
import DeliveryDetailInner from "./DeliveryDetailInner";

// icons
import WebAssetIcon from '@mui/icons-material/WebAsset';


class DeliveryDetail extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: WebAssetIcon,
            buttonLabel: '',
            buttonColor: 'neutral',
            buttonVariant: 'soft',
            ready: true,
            flat: true,
      })
    }

    async beforeModalOpen(){
        return {
            modalLabel: null,
            modalIcon: null,
            mainComponent: DeliveryDetailInner,
            mainComponentProps: {
                ...this.props,
            },
        }
    }

    async beforeModalClose(){
        if (this.props.callBack){
            await this.props.callBack();
        }
    }
}

export default DeliveryDetail
